import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { MaintenanceService } from "./maintenance/maintenance.service";

@Component({
  selector: "app-my-app",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit, OnDestroy {
  private _router: Subscription;

  constructor(
    private router: Router,
    private maintenanceService: MaintenanceService,
  ) {}

  ngOnInit() {
    this.maintenanceService.start();

    this._router = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const body = document.getElementsByTagName("body")[0];
        const modalBackdrop =
          document.getElementsByClassName("modal-backdrop")[0];
        if (body.classList.contains("modal-open")) {
          body.classList.remove("modal-open");
          modalBackdrop.remove();
        }
      });
  }

  ngOnDestroy() {
    this.maintenanceService.stop();
    this._router?.unsubscribe();
  }
}
